import React, {useEffect} from "react";
import {Input, InputAdornment} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {addScanChar, clearScancode, processScan, setScanCode} from "./reg_reducer";
import Clear from "@mui/icons-material/Clear";
import QrCode2 from "@mui/icons-material/QrCode2";

type ScanProps = {
    id: number
}


export default ({id}: ScanProps) => {
    const code = useSelector((state: RootState) => state.reg.scancode);
    const dispatch = useDispatch()

    const handleKeyboard = (e: KeyboardEvent) => {
        if (e.key == 'Enter') {
            console.log("enter")
            dispatch(processScan(id))
            return
        }

        if ((e.target as HTMLInputElement).id != "scan" && e.key.length == 1) {
            dispatch(addScanChar(e.key));
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyboard);
        // cleanup this component
        return () => {
            window.removeEventListener('keydown', handleKeyboard);
        };
    }, []);

    return <Input
        sx={{ml: "auto",width:{xs:"150px", sm:"200px"}}}
        id={"scan"}
        name={"scan"}
        value={code}
        autoComplete={"off"}
        onChange={(e) => dispatch(setScanCode(e.target.value))}
        endAdornment={<InputAdornment position="end" onClick={() => {
            dispatch(clearScancode())
        }}>
            <Clear/>
        </InputAdornment>}
        startAdornment={<InputAdornment position="start"><QrCode2/></InputAdornment>}
        inputProps={{
            onKeyDown: (e) => {
                if (e.key == 'Enter') {
                    dispatch(processScan(id))
                    e.stopPropagation()
                    e.preventDefault()
                }
            }
        }}

    />

}
